import React from "react";
import {
  getPaymentDateStyle,
  getStatusStyle,
  getServerStatusStyle,
  getLoginStatusLightBulbStyle,
  getSpeechActiveStyle,
} from "./styles";

const CustomerTable = ({
  customers,
  sortConfig,
  handleSort,
  filterCustomers,
  handleRowClick,
  handlePay,
  formatDate,
  userRole,
}) => {
  const isAdmin = userRole === "admin";

  // دالة للتحقق من صحة قيمة MonthlyFees
  const isValidMonthlyFees = (value) => {
    if (!value) return false;
    if (value === 0 || value === "0") return false;
    if (value === "" || value === null || value === undefined) return false;
    return true;
  };

  return (
    <table id="customers-table">
      <thead>
        <tr>
          {isAdmin && (
            <th
              data-column="Code"
              className="sortable"
              onClick={() => handleSort("Code")}
            >
              Code
            </th>
          )}
          {!isAdmin && <th data-column="id">#</th>}
          <th
            data-column="Name"
            className="sortable"
            onClick={() => handleSort("Name")}
          >
            Name
          </th>
          <th
            data-column="Governorate"
            className="sortable"
            onClick={() => handleSort("Governorate")}
          >
            Governorate
          </th>
          <th
            data-column="City"
            className="sortable"
            onClick={() => handleSort("City")}
          >
            City
          </th>
          <th
            data-column="NameOwner"
            className="sortable"
            onClick={() => handleSort("NameOwner")}
          >
            Name Owner
          </th>
          {!isAdmin && (
            <th
              data-column="Phone"
              className="sortable"
              onClick={() => handleSort("Phone")}
            >
              Phone
            </th>
          )}
          {!isAdmin && (
            <>
              <th
                data-column="PaymentDate"
                className="sortable"
                onClick={() => handleSort("PaymentDate")}
              >
                Payment Date
              </th>
              <th
                data-column="PriceType"
                className="sortable"
                onClick={() => handleSort("PriceType")}
              >
                Price Type
              </th>
              <th
                data-column="ServerStatus"
                className="sortable"
                onClick={() => handleSort("ServerStatus")}
              >
                Server Status
              </th>
              <th
                data-column="Status"
                className="sortable"
                onClick={() => handleSort("Status")}
              >
                Status
              </th>
              <th
                data-column="SpeechActive"
                className="sortable"
                onClick={() => handleSort("SpeechActive")}
              >
                Speech
              </th>
            </>
          )}
          {isAdmin && (
            <>
              <th className="action-header">Action</th>
              <th
                data-column="PaymentDate"
                className="sortable"
                onClick={() => handleSort("PaymentDate")}
              >
                Payment Date
              </th>
              <th
                data-column="PriceType"
                className="sortable"
                onClick={() => handleSort("PriceType")}
              >
                Price Type
              </th>
              <th
                data-column="ServerStatus"
                className="sortable"
                onClick={() => handleSort("ServerStatus")}
              >
                Server Status
              </th>
              <th
                data-column="Status"
                className="sortable"
                onClick={() => handleSort("Status")}
              >
                Status
              </th>
              <th
                data-column="SpeechActive"
                className="sortable"
                onClick={() => handleSort("SpeechActive")}
              >
                Speech
              </th>
              <th
                data-column="VersionBack"
                className="sortable"
                onClick={() => handleSort("VersionBack")}
              >
                Backend Version
              </th>
              <th
                data-column="VersionFront"
                className="sortable"
                onClick={() => handleSort("VersionFront")}
              >
                Frontend Version
              </th>
            </>
          )}
        </tr>
      </thead>
      <tbody id="customers-table-body">
        {customers.filter(filterCustomers).map((customer) => (
          <tr
            key={customer.Code}
            className={`data-row ${isAdmin ? "admin-row" : "user-row"}`}
            onClick={() => handleRowClick(customer.Code, customer.Name)}
          >
            {!isAdmin && <td className="idCell">{customer.id}</td>}
            {isAdmin && <td className="codeCell">{customer.Code}</td>}
            <td className="nameCell">
              {customer.Name}
              <span 
                style={getLoginStatusLightBulbStyle(customer.LoginStatus, customer.Code || customer.Name)}
                title="Login Status"
              ></span>
            </td>
            <td className="governorateCell">{customer.Governorate}</td>
            <td className="cityCell">{customer.City}</td>
            <td className="nameOwnerCell">{customer.NameOwner}</td>

            {!isAdmin && (
              <>
                <td className="phoneCell">{customer.Phone}</td>
                <td
                  className="paymentDateCell"
                  style={getPaymentDateStyle(customer.PaymentDate)}
                >
                  {customer.PaymentDate ? formatDate(customer.PaymentDate) : ""}
                </td>
                <td className="priceTypeCell">{customer.PriceType}</td>
                <td
                  className="serverStatusCell"
                  style={getServerStatusStyle(customer.ServerStatus)}
                >
                  {customer.ServerStatus}
                </td>
                <td
                  className="StatusCell"
                  style={getStatusStyle(customer.Status)}
                >
                  {customer.Status}
                </td>
                <td
                  className="speechActiveCell"
                  style={getSpeechActiveStyle(customer.SpeechActive)}
                >
                  {customer.SpeechActive ? "Active" : ""}
                </td>
              </>
            )}

            {isAdmin && (
              <>
                <td className="actionCell" style={{ position: "relative" }}>
                  <button
                    className="button"
                    style={{
                      visibility:
                        customer.ServerStatus !== "Active" ||
                        !customer.PaymentDate ||
                        customer.Status === "Offline"
                          ? "hidden"
                          : "visible",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePay(
                        customer.Code,
                        customer.PaymentDate,
                        customer.Name,
                        customer.PriceType,
                        customer.Phone
                      );
                    }}
                  >
                    Pay{isValidMonthlyFees(customer.MonthlyFees) && (
                      <strong>
                        {`${" "}`}
                        <span
                          style={{
                            background: "red",
                            padding: "5px",
                            borderRadius: "10px",
                          }}
                        >{` ${customer.MonthlyFees} `}</span>
                      </strong>
                    )}
                  </button>
                </td>
                <td
                  className="paymentDateCell"
                  style={getPaymentDateStyle(customer.PaymentDate)}
                >
                  {customer.PaymentDate ? formatDate(customer.PaymentDate) : ""}
                </td>
                <td className="priceTypeCell">{customer.PriceType}</td>
                <td
                  className="serverStatusCell"
                  style={getServerStatusStyle(customer.ServerStatus)}
                >
                  {customer.ServerStatus}
                </td>
                <td
                  className="StatusCell"
                  style={getStatusStyle(customer.Status)}
                >
                  {customer.Status}
                </td>
                <td
                  className="speechActiveCell"
                  style={getSpeechActiveStyle(customer.SpeechActive)}
                >
                  {customer.SpeechActive ? "Active" : ""}
                </td>
                <td className="versionBackCell">{customer.VersionBack}</td>
                <td className="versionFrontCell">{customer.VersionFront}</td>
              </>
            )}

            {userRole === "supervisor" && (
              <td className="actionCell" style={{ position: "relative" }}>
                <div style={{ display: "flex", gap: "5px" }}>
                  <button
                    className="button"
                    style={{
                      visibility:
                        customer.ServerStatus !== "Active" ||
                        !customer.PaymentDate ||
                        customer.Status === "Offline"
                          ? "hidden"
                          : "visible",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      // فحص أن Code موجود
                      if (!customer.Code) {
                        console.error("Customer Code is missing!", customer);
                        alert("Error: Customer Code is missing!");
                        return;
                      }
                      
                      // استخدام نفس وظيفة handlePay مع زر "Both"
                      handlePay(
                        customer.Code,
                        customer.PaymentDate,
                        customer.Name,
                        customer.PriceType,
                        customer.Phone
                      );
                    }}
                  >
                    Pay{isValidMonthlyFees(customer.MonthlyFees) && (
                      <strong>
                        {`${" "}`}
                        <span
                          style={{
                            background: "red",
                            padding: "5px",
                            borderRadius: "10px",
                          }}
                        >{` ${customer.MonthlyFees} `}</span>
                      </strong>
                    )}
                  </button>
                </div>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CustomerTable;
